
interface IAlertMessageProps{
    message: string;
}

const AlertMessage = ({message}: IAlertMessageProps) => {
    return(
        <p className='text-xl text-center mt-[16px] p-[20px] font-normal'>
            {message}
        </p>
    );
}

export { AlertMessage };